import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';
import styles from './InputArea.scss';
import Error from '../Icons/dist/components/Error';

var Exclamation = function Exclamation(_ref) {
  var errorMessage = _ref.errorMessage,
      tooltipPlacement = _ref.tooltipPlacement,
      onTooltipShow = _ref.onTooltipShow;
  return React.createElement(
    'div',
    { className: styles.suffix },
    React.createElement(
      Tooltip,
      {
        dataHook: 'inputArea-tooltip', disabled: errorMessage.length === 0,
        placement: tooltipPlacement, onShow: onTooltipShow, alignment: 'center',
        hideDelay: 100, content: errorMessage, moveBy: { x: 0, y: -10 }, overlay: '', maxWidth: '250px',
        textAlign: 'left'
      },
      React.createElement(
        'div',
        { className: styles.errorIcon },
        React.createElement(Error, { size: '1.5em' })
      )
    )
  );
};

Exclamation.defaultProps = {
  errorMessage: '',
  tooltipPlacement: 'right'
};

Exclamation.propTypes = {
  errorMessage: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
  onTooltipShow: PropTypes.func
};

export default Exclamation;
//# sourceMappingURL=Exclamation.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/InputArea/Exclamation.js